import { useEffect } from "react";

const useFocusPageStart = (scrollKey, focusTargetId = "main-content") => {
  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }

    const frameId = window.requestAnimationFrame(() => {
      const focusTarget = document.querySelector(".cookie-consent button")
        || document.getElementById(focusTargetId);

      if (focusTarget) {
        try {
          focusTarget.focus({ preventScroll: true });
        } catch {
          focusTarget.focus();
        }
      }

      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    });

    return () => {
      window.cancelAnimationFrame(frameId);
    };
  }, [focusTargetId, scrollKey]);
};

export default useFocusPageStart;
